import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import VendorAllocation from "./vendorAllocation";
import {getVendorList, postVendor, viewVendorDetails} from "services/redux/brandActivtion/conductCamp/action";

const mapStateToProps = (state) => ({
    vendorDetails: state.ConductCampReducer.vendorDetails,
    vendorList: state.ConductCampReducer.vendorList,
    // vendorAllocate: state.vendorReducer.vendorAllocate
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getVendorList,
            postVendor,
            viewVendorDetails
            // allocateVendor
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(VendorAllocation);
